import React from 'react';
import { motion } from 'framer-motion';
interface RegistrationProgressBarProps {
  currentStep: number;
  totalSteps?: number;
  onStepClick?: (step: number) => void;
}
const BRAND = '#661706';
const PHASES = [{
  activeAt: 1
}, {
  activeAt: 4
}, {
  activeAt: 7
}, {
  activeAt: 9
}];
export function RegistrationProgressBar({
  currentStep,
  totalSteps = 9,
  onStepClick
}: RegistrationProgressBarProps) {
  const clamped = Math.min(Math.max(1, currentStep), totalSteps);
  // Fill % across the 4 milestones (0 / 33 / 66 / 100)
  const fillPct = (() => {
    if (clamped >= 9) return 100;
    if (clamped >= 7) return 66 + (clamped - 7) / (9 - 7) * (100 - 66);
    if (clamped >= 4) return 33 + (clamped - 4) / (7 - 4) * (66 - 33);
    return (clamped - 1) / (4 - 1) * 33;
  })();
  const BOX = 6;
  const LINE_WIDTH = 337;
  return <div className="w-full flex justify-start" style={{
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, sans-serif'
  }} data-id="element-3043" data-mp="1hos05w8jttbv">
      <div className="relative" style={{
      width: LINE_WIDTH,
      height: BOX,
      maxWidth: '100%'
    }} data-id="element-3044" data-mp="3lbl6g6db0f2h">
        {/* Inactive track behind */}
        <div aria-hidden className="absolute" style={{
        top: '50%',
        transform: 'translateY(-50%)',
        left: BOX / 2,
        right: BOX / 2,
        height: 1,
        background: '#D5D5D5'
      }} data-id="element-3045" data-mp="3h9gf5eabvuj0" />
        {/* Active fill */}
        <motion.div aria-hidden className="absolute" style={{
        top: '50%',
        transform: 'translateY(-50%)',
        left: BOX / 2,
        height: 1,
        background: BRAND
      }} initial={false} animate={{
        width: `calc((100% - ${BOX}px) * ${fillPct / 100})`
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} data-id="element-3046" data-mp="32ku1dh0cnatw" />

        {/* Boxes */}
        <div className="absolute inset-0 flex items-center justify-between" data-id="element-3047" data-mp="2jum43fjbzelm">
          {PHASES.map((phase, i) => {
          const filled = clamped >= phase.activeAt;
          return <button key={i} type="button" onClick={() => onStepClick?.(phase.activeAt)} aria-label={`Phase ${i + 1}`} style={{
            width: BOX,
            height: BOX,
            background: filled ? BRAND : '#FFFFFF',
            border: filled ? 'none' : `1px solid ${BRAND}`,
            borderRadius: 1,
            padding: 0,
            cursor: onStepClick ? 'pointer' : 'default',
            transition: 'all 0.2s ease'
          }} data-id="element-3048" data-mp="2ev98a5ahex6w" data-mpi={i} />;
        })}
        </div>
      </div>
    </div>;
}